<template>
  <div class="card">
    <div
      v-b-toggle="`collapseGrants`"
      class="card-header"
    >
      <h3
        :id="`field-9`"
        class="cart-title"
      >
        <a data-action="collapse">{{ field.label ? field.label : field.name }}</a>
      </h3>
      <b-tooltip
        :key="`field-custom-9`"
        placement="topleft"
        boundary="document"
        triggers="hover"
        :target="`field-9`"
        :title="field.tooltip"
      />
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
          <!-- <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              @click="redirectuser($event, [{user_id: userId}, 'researcher.grants.index'])"
            ><i data-feather="edit-3" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapseGrants`"
      v-model="isToggled"
    >
      <div
        class="card-content"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col">
              <div v-if="fromPromotion && convo.days > 0 && isResearcher" class="mb-2">
                <div class="form-check form-switch form-check-inline me-2">
                  <input id="selectAllGrants" class="form-check-input" type="checkbox" :checked="allGrantsSelected" @change="toggleSelectAllGrants">
                  <label class="form-check-label" for="selectAllGrants">Select all</label>
                </div>
              </div>
              <hr>
              <template v-for="(categoryGrants, categoryName) in filteredCategories">
                <p class="badge bg-light-secondary mb-0">
                  {{ categoryName }}
                </p>
                <hr>
                <template v-for="(yearGrants, year) in categoryGrants">
                  <p class="badge bg-light-info">
                    {{ year }}
                  </p>
                  <ul
                    v-for="minigrant in yearGrants"
                    :key="'grant-' + minigrant.id"
                    class="abridged-cv__list"
                  >
                    <li v-if="canSeeMinigrant(minigrant)">
                      <div
                        v-if="fromPromotion && convo.days > 0 && isResearcher"
                        class="form-check form-switch form-check-inline me-2"
                      >
                        <input
                          :id="'grantContent' + minigrant.id"
                          type="checkbox"
                          class="form-check-input"
                          :checked="selectedGrants.includes(minigrant.id.toString())"
                          @change="handleGrantClick(minigrant, $event)"
                        >
                      </div>
                      <strong
                        :class="minigrant.from_personnel ? 'text-danger' : ''"
                      >{{ minigrant.begin_date_formatted }} - {{ minigrant.end_date_formatted ? minigrant.end_date_formatted : 'Present' }}</strong>
                      <template v-if="minigrant.grant_type_id != 4 && minigrant.grant_type_id != 16">
                        <span v-if="minigrant.funding_type_name">
                          {{ minigrant.funding_type_name }}
                        </span>
                        <span v-if="minigrant.programme_name">
                          {{ minigrant.programme_name }}
                        </span>
                        <span v-if="minigrant.title">
                          "{{ minigrant.title }}"
                        </span>
                        <span v-if="minigrant.position_name">
                          Role: <strong>{{ minigrant.position_name }}</strong>
                        </span>
                        <span v-if="minigrant.type_personnel_name">
                          {{ minigrant.type_personnel_name }}
                        </span>
                        <span v-if="minigrant.total_amount">
                          Total amount: <strong>{{ minigrant.total_amount }}€</strong>
                        </span>
                        <span v-if="minigrant.total_amount_group">
                          Total amount given to your group: <strong>{{ minigrant.total_amount_group }}€</strong>
                        </span>
                      </template>
                      <template v-if="minigrant.grant_type_id == 16">
                        <span v-if="minigrant.funding_type_name">
                          {{ minigrant.funding_type_name }}
                        </span>
                        <!-- <span v-if="minigrant.programme_name">
                        · {{ minigrant.programme_name }}
                      </span> -->
                        <span v-if="minigrant.type_personnel_name">
                          · {{ minigrant.type_personnel_name }}
                        </span>
                        <span v-if="minigrant.holder_name">
                          · {{ minigrant.holder_name }}
                        </span>
                        <span v-if="minigrant.dedication">
                          · {{ minigrant.dedication }}%
                        </span>
                      </template>
                      <template v-if="minigrant.custom_personnels.length > 0">
                        <a
                          class="ms-1 btn btn-sm bg-light-secondary"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Edit"
                          @click="redirectuser($event, [{id: minigrant.id}, 'researcher.grants.edit'])"
                        ><i data-feather="edit-3" /></a>
                        <div
                          v-for="personnel in minigrant.custom_personnels"
                          :key="personnel.id"
                          class="ps-1 pt-1"
                        >
                          · {{ personnel.from }} - {{ personnel.to ? personnel.to : 'Present' }} - {{ personnel.type_name }}{{ personnel.name ? ' - ' + personnel.name : '' }}
                        </div>
                      </template>
                      <a
                        v-if="minigrant.custom_personnels.length == 0"
                        class="ms-1 btn btn-sm bg-light-secondary"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                        @click="redirectuser($event, [{id: minigrant.id}, 'researcher.grants.edit'])"
                      ><i data-feather="edit-3" /></a>
                    </li>
                  </ul>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<style scoped>
  .abridged-cv__list {
    list-style-type: none;
    padding-left: 0;
  }
</style>

<script>
import { mapGetters } from 'vuex'
import { BCollapse, BTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
    BTooltip,
  },
  props: {
    userId: { type: Number, required: true, default: () => {} },
    yearBetween: { type: Object, required: true, default: () => {} },
    promo: { type: Object, required: false, default: () => {} },
    field: { type: Object, required: true },
    fromPromotion: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      loading: true,
      isToggled: true,
      optimisticSelectedGrants: new Set(),
    }
  },
  computed: {
    ...mapGetters({
      scientificGrants: 'users/scientificGrants',
      selectedGrants: 'convo/selectedGrants',
      toggled: 'preview/toggled',
      convo: 'convo/convo',
      loggedUser: 'auth/admin',
    }),
    isResearcher() {
      return this.loggedUser.roles.includes('researcher')
    },
    visibleGrants() {
      const grants = []
      const cats = this.filteredCategories || {}
      Object.values(cats).forEach(years => {
        Object.values(years).forEach(list => {
          list.forEach(g => grants.push(g))
        })
      })
      return grants
    },
    visibleGrantIds() {
      return this.visibleGrants.map(g => g.id?.toString()).filter(Boolean)
    },
    allGrantsSelected() {
      const ids = this.visibleGrantIds
      return ids.length > 0 && ids.every(id => this.selectedGrants.includes(id) || this.optimisticSelectedGrants.has(id))
    },
    filteredCategories() {
      if (!this.scientificGrants) return {}
      if ((!this.fromPromotion || this.convo.days > 0) && this.isResearcher) return this.scientificGrants
      
      return Object.entries(this.scientificGrants).reduce((acc, [category, years]) => {
        const filteredYears = this.filterYears(years)
        if (Object.keys(filteredYears).length > 0) {
          acc[category] = filteredYears
        }
        return acc
      }, {})
    },
  },
  watch: {
    userId() {
      this.reloadData()
    },
    toggled() {
      if (this.toggled !== this.isToggled) {
        this.isToggled = this.toggled
      }
    },
    yearBetween() {
      this.reloadData()
    },
    selectedGrants() {
      this.optimisticSelectedGrants = new Set()
    },
  },
  async mounted() {
    await this.reloadData()
    if (this.fromPromotion) {
      await this.loadSelectedGrants()
    }
  },
  methods: {
    canSeeMinigrant(minigrant) {
      if (!this.fromPromotion) return true

      const begin = minigrant.begin_date ? new Date(minigrant.begin_date) : null
      const end = minigrant.end_date ? new Date(minigrant.end_date) : null

      const beginYear = begin ? begin.getFullYear() : null
      const endYear = end ? end.getFullYear() : Infinity
      const getYearValue = (val) => {
        if (val == null) return null
        if (typeof val === 'number') return val
        if (typeof val === 'string') {
          const p = parseInt(val, 10)
          return Number.isNaN(p) ? null : p
        }
        if (val instanceof Date) return val.getFullYear()
        return null
      }

      const rangeStart = getYearValue(this.yearBetween.start) || getYearValue(this.yearBetween.start_date) || getYearValue(this.yearBetween.from) || getYearValue(this.convo.start_date) || getYearValue(this.convo.start)
      const rangeEnd = getYearValue(this.yearBetween.end) || getYearValue(this.yearBetween.end_date) || getYearValue(this.yearBetween.to) || getYearValue(this.convo.end_date) || getYearValue(this.convo.end)

      if (!beginYear || Number.isNaN(rangeStart) || Number.isNaN(rangeEnd)) {
        // If dates are invalid or missing, be permissive and show the grant
        return true
      }

      // Overlap check: grant starts on/before range end and ends on/after range start
      return beginYear <= rangeEnd && endYear >= rangeStart
    },
    toggleSelectAllGrants() {
      const allSelected = this.allGrantsSelected
      for (const grant of this.visibleGrants || []) {
        this.$emit('item-selected', {
          origenable_id: grant.id,
          type: 'App\\Models\\Grant',
          selected: !allSelected,
        })
      }
      if (!allSelected) {
        this.optimisticSelectedGrants = new Set(this.visibleGrantIds)
      } else {
        this.optimisticSelectedGrants = new Set()
      }

      setTimeout(async () => {
        await this.loadSelectedGrants()
      }, 1000)
    },
    isGrantChecked(id) {
      const sid = id?.toString()
      return this.selectedGrants.includes(sid) || this.optimisticSelectedGrants.has(sid)
    },
    
    filterYears(years) {
      return Object.entries(years).reduce((acc, [year, grants]) => {
        const filteredGrants = this.filterGrants(grants)
        if (filteredGrants.length > 0) {
          acc[year] = filteredGrants
        }
        return acc
      }, {})
    },
    filterGrants(grants) {
      if (this.loggedUser.roles.includes('super-admin') && this.convo.year < 2026) {
        return grants
      }

      if (this.isResearcher && (!this.fromPromotion || this.convo.year < 2026 || this.convo.days > 0)) {
        return grants
      }
      // For non-researchers or when in promotion mode with days <= 0, only show selected grants
      return grants.filter(grant => this.selectedGrants.includes(grant.id?.toString()))
    },
    async reloadData() {
      this.loading = true
      this.isToggled = this.toggled
      if (this.promo && this.promo.id && !this.promo.active_researcher) {
        await this.$store.dispatch('users/fetchUserScientificGrantsFreezed', { convo: this.promo.id, userId: this.userId, yearBetween: this.yearBetween })
      } else {
        await this.$store.dispatch('users/fetchUserScientificGrants', { userId: this.userId, yearBetween: this.yearBetween })
      }

      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
      this.loading = false
    },
    async redirectuser(event, redirection) {
      event.stopPropagation()
      this.$emit('goToIndex', redirection)
    },

    handleGrantClick(grant, event) {
      // Get the current checkbox state from the event
      const isChecked = event.target.checked

      this.$emit('item-selected', {
        origenable_id: grant.id, // This is the actual grant ID
        type: 'App\\Models\\Grant',
        selected: isChecked, // Use the actual checkbox state
      })
    },
    async loadSelectedGrants() {
      if (!this.fromPromotion) return

      try {
        await this.$store.dispatch('convo/fetchSelectedPromotionScientificProductions', {
          origenableType: 'App\\Models\\Grant',
          userId: this.userId,
        })
      } catch (error) {
        console.error('Error loading selected grants:', error)
      }
    },
    // Clear optimistic selections when store updates
    // watch selectedGrants in component-level watch below
  },

}
</script>
